import React, { useEffect } from "react";
import { DevtoolsContext } from "./devtoolsContext";

export const DevtoolsProvider: React.FC<{ children: React.ReactNode; setDevtoolsValue: (value: boolean) => void }> = ({ children, setDevtoolsValue }) => {
  const [isDevtoolsOpen, setIsDevtoolsOpen] = React.useState(false);

  function toggleDevtools() {
    setIsDevtoolsOpen((old) => !old);
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === "d") {
      toggleDevtools();
    }
  }

  useEffect(() => {
    setDevtoolsValue(isDevtoolsOpen);
  }, [isDevtoolsOpen, setDevtoolsValue]);

  useEffect(() => {
    (window as unknown as Window & { toggleDevtools: () => void }).toggleDevtools = () => setIsDevtoolsOpen((old) => !old);
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return <DevtoolsContext.Provider value={{ isDevtoolsOpen, toggleDevtools }}>{children}</DevtoolsContext.Provider>;
};
